import { calcNbrMonthsBtwnDates } from "../../../objects/CommonUse/nbr_months_btwn_dates_calc";
import rollForwardDate from "../objects/roll_forward_date_function";

export const calculatePaymentHistory = (paymentHistory, gameDate, nbrMonths, minPayment, amtPaid, payType) => {
    // minPayment is the minPayment for the current statement date
    //  payment history has month, status ('onTime', 'paidLate', 'unpaid'), minimum pay amt, amtApplied;
  
    // step 1 - add new months to paymentHistory (assume 'unpaid');
    let payMonth = gameDate;
    let monthMinPayment = (+minPayment / +nbrMonths).toFixed(2);
    if (payType === "endOfMonth"){
        for (let i=0; i<nbrMonths; i++){
            const payHistoryObj = {month: payMonth, payStatus: "new", minPayAmt: monthMinPayment, amtApplied: 0};
            paymentHistory.push(payHistoryObj);
            payMonth = rollForwardDate(payMonth, 1);
        }
    }

    // step 2 - remove months older than 7 years (84 months)
    const extraMonths = paymentHistory.length - 84;
    if (extraMonths > 0){
        paymentHistory.splice(0,extraMonths);
    }
      
    // step 3 - apply amount paid to oldest unpaid payments first!
    const newGameDate = rollForwardDate(gameDate, nbrMonths);
    let amtRemaining = +amtPaid;
    for (let i=0; i<paymentHistory.length; i++){
        if (paymentHistory[i].payStatus === "unpaid" || paymentHistory[i].payStatus === "new"){
            const monthsDiff = calcNbrMonthsBtwnDates(paymentHistory[i].month, newGameDate);
            if (amtRemaining >= +paymentHistory[i].minPayAmt){
                if (paymentHistory[i].payStatus === "new" || 
                    monthsDiff <= nbrMonths){
                    paymentHistory[i].payStatus = "onTime";
                }else{
                    paymentHistory[i].payStatus = "paidLate";
                }
                paymentHistory[i].amtApplied = paymentHistory[i].minPayAmt;
                amtRemaining -= +paymentHistory[i].minPayAmt;
            }else{
                if (paymentHistory[i].payStatus === "new"){
                    if (monthsDiff < nbrMonths){
                        // leave payStatus as "new"
                    }else{
                        paymentHistory[i].payStatus = "unpaid";
                    }
                }
                paymentHistory[i].amtApplied = amtRemaining.toString();
                amtRemaining = 0;
            }
        }
    }
    return paymentHistory;

}
export default calculatePaymentHistory;